export const initialState = {
  category: {},
  loading: false,
  error: "",
};
